import React from 'react';
import { Helmet } from 'react-helmet-async';
import { Heading, Paragraph } from '@sovryn/ui';
export const EmailVerificationState = ({ metaTitle, title, subtitle, }) => (React.createElement(React.Fragment, null,
    React.createElement(Helmet, null,
        React.createElement("title", null, metaTitle)),
    React.createElement("div", { className: "w-full flex flex-col items-center justify-center m-auto max-w-[51rem] text-gray-10 px-7 py-11 lg:py-16 bg-gray-90 mt-24 mb-5 lg:mt-[15.875rem] rounded" },
        React.createElement(Heading, { className: "font-medium text-2xl mb-10 lg:mb-12 text-center" }, title),
        React.createElement(Paragraph, { className: "max-w-xl leading-[1.125rem] font-normal text-sm lg:text-base text-center lg:px-4" }, subtitle))));
